import React from 'react';
import 'aws-amplify/auth/enable-oauth-listener';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import awsmobile from './aws-exports';
import { initErrorReporting } from './utils/errorReporter';

awsmobile.oauth.domain = 'login.spiggl.com';

Amplify.configure(awsmobile);
initErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

reportWebVitals();
